import { String } from "@siteimprove/alfa-string";
/**
 * @public
 */
export class Diagnostic {
    static of(message) {
        return new Diagnostic(String.normalize(message, false));
    }
    _message;
    constructor(message) {
        this._message = message;
    }
    get message() {
        return this._message;
    }
    equals(value) {
        return value instanceof Diagnostic && value._message === this._message;
    }
    hash(hash) {
        hash.writeString(this._message);
    }
    toJSON(options) {
        return {
            message: this._message,
        };
    }
}
/**
 * @public
 */
(function (Diagnostic) {
    function isDiagnostic(value) {
        return value instanceof Diagnostic;
    }
    Diagnostic.isDiagnostic = isDiagnostic;
    Diagnostic.empty = Diagnostic.of("No extra information");
})(Diagnostic || (Diagnostic = {}));
//# sourceMappingURL=diagnostic.js.map